export enum StoreInventoryItems {
    none,
    barrier,
    clock,
    coconut,
    nuke,
    skull,
    smasher,
    addTimePerk,
    cherryBonusPerk,
    robotInvaderPack,
    rainbowPerk,
    chainBonusPerk,
    tntPerk,
    unlockAll,
    coinDoubler,
    starBoosterPerk,
    mushroom,
    desertPack,
    tapjoyCoins,
    facebookCoins,
    twitterCoins,
    googlePlusCoins,
    coinPack1,
    coinPack2,
    coinPack3,
    coinPack4,
    coinPack5,
    coinPack6,
    freezeDrop1,
}
